import { CommonHttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { PaymentMethodModel } from '../models/payment-method.model';

@Injectable()
export class CartResumeService {
    constructor(
        protected http: CommonHttpService
    ) {}

    /**
     * This call API to index cart resume data.
     **/
    public index(): Observable<Response> {
        return this.http.get(
            '/checkout/cart/resume'
        );
    }

    /**
     * Call API to update resume values by some PaymentMethod instance.
     **/
    public updateBySelectedPaymentMethod(paymentMethod: PaymentMethodModel) {
        return new Observable(observable => {
            this.http.useAuth().put('/checkout/payment/resume', {
                'payment_method_id': paymentMethod.id
            }).subscribe((res: Response) => {
                observable.next(res.json().data);
                observable.complete();
            }, (err: Response) => {
                observable.error(err.json());
            });
        });
    }
    /** Call API to validate coupon code */
    public updateByCouponCode(couponCode: string) {
        return new Observable(observable => {
            this.http.useAuth().put('/checkout/payment/resume', {
                'coupon_code': couponCode
            }).subscribe((res: Response) => {
                observable.next(res.json().data);
                observable.complete();
            }, (err: Response) => {
                observable.error(err.json());
            });
        });
    }
    /** Call API to remove all coupon codes applied previously. */
    public removeCouponCode() {
        return new Observable(observable => {
            this.http.useAuth()
                .put('/checkout/payment/resume', {'coupon_code': null})
                .subscribe((res: Response) => {
                    observable.next(res.json().data);
                    observable.complete();
                }, (err: Response) => {
                    observable.error(err.json());
                });
        });
    }

    /**
     * Call API to remove all payment methods conditions and update values.
     **/
    public clearPaymentMethodDiscount() {
        return new Observable(observable => {
            this.http.useAuth()
                .put('/checkout/payment/resume', {'payment_method_id': null})
            .subscribe(() => {
                observable.next(null);
                observable.complete();
            }, (err: Response) => {
                observable.error(err.json());
            });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/services/cart-resume.service.ts